import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import {
  Link,
  Redirect,
  NavLink,
  useHistory,
  useLocation,
} from "react-router-dom";
import PropTypes from "prop-types";
import { Icon } from "react-icons-kit";
import { filter } from "react-icons-kit/fa/filter";
import { Country } from "country-state-city";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import InputRange from "react-input-range";
import {
  freelancerAllGet,
  freelancerGetbyId,
} from "../../actions/freelancerProfile";
import InvitationModal from "./invitationModal";
import { Input2 } from "../../components/input/input";

import Skeleton from "./../../components/skeleton";
import {Helmet} from "react-helmet";
import Search from '../job/search';
import { skillsGet } from "../../actions/clientProfile";


const Talent = ({
  auth: { isAuthenticated, user },
  freelancerProfile: { freelancerList, freelancerprofile },
  freelancerGetbyId,
  clientProfile: { skills },
  skillsGet
}) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [profileTalentData, setProfileTalentData] = useState(null);
  const [inviteModal, setInviteModal] = useState(false);
  const [hireModal, setHireModal] = useState(false);
  const [selectedfreelancer, setSelectedfreelancer] = useState(null);
  const [talentdetails, setTalentdetails] = useState(null);
  const [error, setError] = useState("");
  const [locationError, setLocationError] = useState("");
  const [categoryError, setCategoryError] = useState("");

  const [hrate, setHourlyRate] = useState("10");

  const [showtalent, setShowTalent] = useState(false);
  const [loadingTest, setLoadingTest] = useState(true);
  const handleClosetalent = () => {
    setShowTalent(false);
    setTalentdetails();
  };

  const [formData, setFormData] = useState({
    priceRange: "",
    location: "United Kingdom",
    category: "",
  });

  const { priceRange, location, category } = formData;

  const onChangeVal = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [state, setstate] = useState({
    value: { min: 2, max: 1000 },
  });

  const searchInput = useRef("");

  const [value, setValue] = useState("");

  const [show, setShow] = useState(false);
  const [Hirecheck, setcheck] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  //const storedValue = JSON.parse(localStorage.getItem('search'));
  const homepage_query = useLocation();
  const searchParams = new URLSearchParams(homepage_query.search);
  const storedValue = searchParams.get("value");

  const [currentPage, setCurrentPage] = useState(1);
  const [resultsPerPage, setResultsPerPage] = useState(10);
  const totalPages = Math.ceil(profileTalentData?.length / resultsPerPage);

  useEffect(() => {
    scrollToTop();
  }, [currentPage]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  function scrollToTop() {
    window.scrollTo(0, 0);
  }

  useEffect(() => {
    //debugger;
    dispatch(freelancerAllGet());
    skillsGet();
    if (storedValue) {
      setValue(storedValue);
      localStorage.removeItem("search");
    }
  }, []);

  useEffect(() => {
    //debugger;
    if (storedValue) {
      handleSearch(storedValue);
    } else {
      if (freelancerList !== null) {
        setProfileTalentData(
          freelancerList?.map((item) => ({
            imageLink: item?.profilePhoto?.photo_link,
            name: item?.user_id?.first_name + " " + item?.user_id?.last_name,
            title: item?.expertise?.category,
            location: item?.location?.country,
            hourlyRate: item?.hourlyRate?.hourly_rate,
            skills: [item?.expertise?.skills],
            _id: item?._id,
            verification: item?.verification,
          }))
        );
      }
    }
  }, [freelancerList]);

  const countries = Country.getAllCountries();

  const profileview = async (e) => {


  if(!isAuthenticated){
    //dispatch(setAlert("Sign In to see expert profile","danger", 3000));

    return;
  }


    //console.log(e);
    freelancerGetbyId(e._id).then((res) => {
      console.log(res.data);
      if (res.data) {
        setShowTalent(true);
      }
    });
    console.log(freelancerprofile);
  };

  const handleSearch = (search) => {
    const formattedSearchQuery = search.toLowerCase().replace(/\s/g, '');
    try {
      const filteredList = freelancerList?.filter(
        (freelancer) =>
          freelancer?.user_id?.first_name
            ?.toLowerCase()
            .includes(search.toLowerCase()) ||
          freelancer?.user_id?.last_name
            ?.toLowerCase()
            .includes(search.toLowerCase()) ||
          (freelancer?.user_id?.first_name?.toLowerCase() + freelancer?.user_id?.last_name?.toLowerCase())?.includes(formattedSearchQuery) ||
          freelancer?.expertise?.skills
            ?.toLowerCase()
            .includes(search.toLowerCase()) ||
          freelancer?.location?.country
            ?.toLowerCase()
            .includes(search.toLowerCase()) ||
          ( freelancer?.expertise?.category &&
              freelancer?.expertise?.category
                ?.toLowerCase()
                .includes(search.toLowerCase()))
      );

      console.log(filteredList);

      // update the profileTalentData with the filtered list
      setProfileTalentData(filteredList);

      if (filteredList.length > 0) {
        setProfileTalentData(
          filteredList.map((item) => ({
            imageLink: item?.profilePhoto?.photo_link,
            name: item?.user_id?.first_name + " " + item?.user_id?.last_name,
            title: item?.expertise?.category,
            location: item?.location?.country,
            hourlyRate: item?.hourlyRate?.hourly_rate,
            skills: [item?.expertise?.skills],
            _id: item?._id,
            verification: item?.verification,
          }))
        );
      }

      //setFilteredData(filteredList);
      setCurrentPage(1);
    } catch (err) {
      console.log(err);
    }
    //localStorage.removeItem('search');
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    // Check if the input value is a valid number
    if (value && isNaN(Number(value))) {
      // If not, set the error message
      setError("Hourly rate can only be in numbers");
    } else {
      // If it's a valid number, clear the error message
      setError("");
    }
    setHourlyRate(e.target.value);
  };

  const clearFilter = () => {
    setFormData({ ...formData, ["location"]: "" });
    setFormData({ ...formData, ["category"]: "" });
    setHourlyRate("10");
    setProfileTalentData(
      freelancerList?.map((item) => ({
        imageLink: item?.profilePhoto?.photo_link,
        name: item?.user_id?.first_name + " " + item?.user_id?.last_name,
        title: item?.expertise?.category,
        location: item?.location?.country,
        hourlyRate: item?.hourlyRate?.hourly_rate,
        skills: [item?.expertise?.skills],
        _id: item?._id,
        verification: item?.verification,
      }))
    );
  };

  const filtersearch = () => {
    try {
      //console.log(location);
      const filteredList = freelancerList?.filter(
        (freelancer) =>
          (hrate && freelancer.hourlyRate.hourly_rate <= parseFloat(hrate) ) ||
          (location && freelancer.location.country
            ?.toLowerCase()
            .includes(location?.toLowerCase()))
      );

      // update the profileTalentData with the filtered list
      setProfileTalentData(filteredList);
      console.log(filteredList.length);

      if (filteredList.length > 0) {
        setProfileTalentData(
          filteredList.map((item) => ({
            imageLink: item?.profilePhoto?.photo_link,
            name: item?.user_id?.first_name + " " + item?.user_id?.last_name,
            title: item?.expertise?.category,
            location: item?.location?.country,
            hourlyRate: item?.hourlyRate?.hourly_rate,
            skills: [item?.expertise?.skills],
            _id: item?._id,
            verification: item?.verification,
          }))
        );
      }
      setCurrentPage(1);
    } catch (err) {
      console.log(err);
    }
  };

  const handleFilterAndClose = () => {
    if(hrate == '' && location == ''){
      setCategoryError("Hourly rate or location is required");
    }
    setLocationError("");
    filtersearch();
    setShow(false);
  };

  const startIndex = (currentPage - 1) * resultsPerPage;
  const endIndex = startIndex + resultsPerPage;
  const currentResults = profileTalentData ? [...profileTalentData].slice(startIndex, endIndex) : null;

  return (
    <div className="main-page page-dashboard page-talent">
      <Helmet>
        <title>Find Talent</title>
      </Helmet>
      <div className="container">
        <section className="bg-white rounded shadow-sm p-5 mb-3">
          {/*<Tabs defaultActiveKey="searchTab" id="uncontrolled-tab-example">*/}
          {/*<Tab eventKey="searchTab" title="Search">*/}

          <div className="row advanced-search">
            <div className="col-md-10">
              <div className="input-group search-engine">
                {/** <input type="text" value={value}  onChange={e => setValue(e.target.value)} className="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" />
                            <div className="input-group-prepend">
                                {/*}<Link to="#" className="btn btn-primary text-light" id="basic-addon1"><i className="fa fa-search fa-fw p-0" aria-hidden="true"></i></Link>{
                                <Link to="#" className="btn btn-primary text-light" id="basic-addon1" onClick={handleSearch}><i className="fa fa-search fa-fw p-0" aria-hidden="true"></i></Link>
                            </div>*/}

                {/** <input
                  type="text"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      handleSearch(value);
                    }
                  }}
                  className="form-control"
                  placeholder="Search"
                  aria-label="Search"
                  aria-describedby="basic-addon1"
                />*/}
                <Search
                    suggestions={skills.length > 0 ? skills.map(item => item.skill_name) : []}
                    setInput={setValue}
                    handleSearch={() => handleSearch(value)}
                    pre_value={value}
                  />
               
              </div>
            </div>
            <div className="col-md-2 pl-0">
              <Button onClick={handleShow} className="btn btn-block">
                <Icon icon={filter} /> Filters
              </Button>
              {console.log(show)}
              {show == true ? (
                <Modal
                  show={show}
                  size="sm"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  onHide={handleClose}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Search Talent</Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                    <div className="container">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group cyber-form-control">
                            <label className="form-label">
                              Hourly Rate Range
                            </label>
                            <div className="mt-2">
                              <Input2
                                labelfor={`Hourly Rate`}
                                // label={`Username`}
                                placeholder={`Hourly Rate`}
                                required={true}
                                type={"text"}
                                handlerOnChange={(e) => onChange(e)}
                                value={hrate}
                                parentclass={"mb-2"}
                                name="hourly_rate"
                              >
                                {/* <span className="error-text">Error</span> */}
                              </Input2>
                              {error && (
                                <div style={{ color: "red" }}>{error}</div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group cyber-form-control">
                            <label className="form-label">
                              Country/Location
                            </label>
                            <div className="input-group mt-2 mb-2">
                              <select
                                className="form-control"
                                name="location"
                                value={location}
                                onChange={(e) => onChangeVal(e)}
                              >
                                <option value="">Please Select</option>
                                {countries.map((item) => (
                                  <option
                                    key={item.name}
                                    value={item.name}
                                    data-isoCode={item.isoCode}
                                  >
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {locationError && (
                              <div style={{ color: "red" }}>
                                {locationError}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* <div className="row">
                        <div className="col-md-12">
                          <div className="form-group cyber-form-control">
                            <label className="form-label">
                              Service Category
                            </label>
                            <div className="input-group mt-2 mb-2">
                              <select
                                className="form-control"
                                name="category"
                                value={category}
                                onChange={(e) => onChangeVal(e)}
                              >
                                <option value="">Please Select</option>
                                <option value="Application security">
                                  Application security
                                </option>
                                <option value="Network and infrastructure security">
                                  Network and infrastructure security
                                </option>
                                <option value="Intrusion detection and penetration testing">
                                  Intrusion detection and penetration testing
                                </option>
                                <option value="Digital forensics and incident response">
                                  Digital forensics and incident response
                                </option>
                                <option value="Endpoint protection and mobile security">
                                  Endpoint protection and mobile security
                                </option>
                                <option value="Data governance, risk and compliance">
                                  Data governance, risk and compliance
                                </option>
                              </select>
                            </div>

                            {categoryError && (
                              <div style={{ color: "red" }}>
                                {categoryError}
                              </div>
                            )}
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </Modal.Body>

                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={handleFilterAndClose}
                      disabled={error}
                    >
                      Apply Filter
                    </Button>
                  </Modal.Footer>
                </Modal>
              ) : (
                console.log("Null")
              )}

              {showtalent == true ? (
                <Modal
                  show={showtalent}
                  size="md"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  onHide={handleClosetalent}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      Talent Details -{" "}
                      {freelancerprofile.profile.user_id.first_name +
                        " " +
                        freelancerprofile.profile.user_id.last_name}
                    </Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                    <div className="container">
                      <div className="row">
                        <div className="col-12">
                          <h6 className="text-primary">Title</h6>
                          <p className="text-muted text-justify">
                            {freelancerprofile.profile.titleAndOverview.title}
                          </p>
                          <br />
                          <h6 className="text-primary">Expertise</h6>
                          <p className="text-muted">
                            {freelancerprofile.profile.expertise.skills}
                          </p>
                          <br />
                          <h6 className="text-primary">Expert Level</h6>
                          <p className="text-muted">
                            {freelancerprofile.profile.expertLevel.expert_level}
                          </p>
                          <br />
                          <h6 className="text-primary">Hourly Rate</h6>
                          <p className="text-muted">
                            {freelancerprofile.profile.hourlyRate.hourly_rate +
                              "$"}
                          </p>
                          <br />
                          {freelancerprofile?.profile?.education?
                            <>
                              <h6 className="text-primary">Education</h6>
                              <p className="text-muted">
                                {
                                  `
                                  ${freelancerprofile.profile?.education?.degree ? freelancerprofile.profile?.education?.degree + " - ": ""}
                                  ${freelancerprofile.profile?.education
                                    ?.specialization? freelancerprofile.profile?.education
                                    ?.specialization + " - ": "" }
                                  ${freelancerprofile.profile?.education?.provider? freelancerprofile.profile?.education?.provider: "" }
                                  ` 
                                }
                              </p>
                              <br />
                            </>
                            :
                            <p>Not provided</p>
                          }
                          <h6 className="text-primary">Location</h6>
                          <p className="text-muted">
                            {freelancerprofile.profile.location.country}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClosetalent}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
              ) : (
                console.log("Null")
              )}
            </div>
          </div>
        </section>
        {/*            <div className="row">
                <div className="col-md-12 border p-4 rounded">
                    <h6>Add details about your company</h6>
                    <p>Tell us about your company details to improve your match and invite your coworkers to help you hire.</p>
                    <Link to="#" className="btn btn-info">Add Details</Link>
                </div>
            </div>*/}


            
        {/**<Alert /> */}


        <section className="bg-white rounded shadow-sm">
          <div className="d-flex justify-content-end">
            <div
              className="pt-4 px-4 text-primary cursor-pointer"
              onClick={clearFilter}
            >
              Clear Filters
            </div>
          </div>
          {currentResults === null && (
            [0,1,2,3,4].map(i => (
              <div key={i} className="border-bottom pb-2">
                <div className="row">
                  <div className="col-md-3 d-flex justify-content-center align-items-center">
                    <Skeleton width={130} height={130} borderRadius={130} />
                  </div>
                  <div className="col-md-6 pt-1">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Skeleton width={180} height={30} />
                    </div>
                    <p className="font-weight-bold mb-0">
                      <Skeleton width={120} height={12} />
                    </p>
                    <p className="text-muted mb-0">
                      <Skeleton width={100} height={10} />
                    </p>

                    <p>
                      <Skeleton width={70} height={12} />
                    </p>
                  </div>
                </div>
              </div>
            ))
          )}
          {currentResults && currentResults.length > 0 ? (
            currentResults.length > 0 &&
            [...currentResults].reverse().map((profileTalentDataItem, index) => (
              <div className="freelancer-list" key={index}>
                <div className="row">
                  {console.log(profileTalentDataItem)}
                  <div
                    className="col-md-3"
                    onClick={() => {
                      profileview(profileTalentDataItem);
                    }}
                  >
                    <div
                      className="rounded-circle overflow-hidden"
                      style={{
                        height: "130px",
                        width: "130px",
                        margin: "0 auto",
                      }}
                    >
                      <img
                        className="img-fluid"
                        src={profileTalentDataItem.imageLink}
                        style={{
                          objectFit: "cover",
                          height: "100%",
                          width: "100%",
                        }}
                        alt={profileTalentDataItem.name}
                      />
                    </div>
                  </div>
                  <div
                    className="col-md-6 pt-1"
                    onClick={() => {
                      profileview(profileTalentDataItem);
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <h3 className="text-primary mb-0">
                        {profileTalentDataItem.name}
                      </h3>

                      {profileTalentDataItem.verification === true ? (
                        <img
                          src="assets/images/checkmark.png"
                          className="img-fluid user-pict-img"
                          alt="Cyber2Cyber"
                          title="Cyber to Cyber Verified Expert"
                          style={{
                            width: "4%",
                            height: "15%",
                            position: "relative",
                            marginLeft: "0px",
                          }}
                        />
                      ) : (
                        console.log("check false")
                      )}
                    </div>
                    <p className="font-weight-bold mb-0">
                      {profileTalentDataItem.title}
                    </p>
                    <p className="text-muted mb-0">
                      {profileTalentDataItem.location}
                    </p>

                    <p>
                      <span className="font-weight-bold">
                        $
                        {profileTalentDataItem.hourlyRate !== "N/A"
                          ? profileTalentDataItem.hourlyRate
                          : "N/A"}
                        .00
                      </span>{" "}
                      / hr
                    </p>
                    {/*}<p><span className="font-weight-bold">${profileTalentDataItem.hourlyRate}.00</span> / hr</p>{*/}

                    {/*<p className="text-primary font-weight-bold"><Icon icon={fileO} /> Completed 13 SEO jobs on CyberToCyber</p>*/}
                    {/* {profileTalentDataItem.skills.length > 0 && <p>Has <span className="font-weight-bold">{profileTalentDataItem.skills.length} relevant skills</span> to your job</p>} */}
                    <div className="tags-row mb-3">
                      {profileTalentDataItem.skills.length > 0 &&
                        profileTalentDataItem.skills.map(
                          (profileTalentDataItemSkills, index) => {
                            if (profileTalentDataItemSkills.includes(",")) {
                              const splitSkills =
                                profileTalentDataItemSkills.split(",");
                              return splitSkills.map((skill, i) => (
                                <>
                                  {skill.trim().length > 0 && (
                                    <span
                                      key={`${index}-${i}`}
                                      className="badge bg-secondary mr-2 mt-1"
                                    >
                                      {skill}
                                    </span>
                                  )}
                                </>
                              ));
                            } else {
                              return (
                                <span
                                  key={index}
                                  className="badge bg-secondary mr-2 mt-1"
                                >
                                  {profileTalentDataItemSkills}
                                </span>
                              );
                            }
                          }
                        )}

                      {/*<span className="border rounded pr-1 pl-1 pt-2 pb-2 ml-2 mt-1"><Link to="#" className="text-danger font-weight-bold">5 More</Link></span>*/}
                    </div>
                  </div>
                  <div className="col-md-3 text-center">
                    {isAuthenticated && user.type == "Client" ? (
                      <>
                        <div className="mb-2">
                          <button
                            onClick={() => {
                              setHireModal(true);
                              setInviteModal(true);
                              setSelectedfreelancer(profileTalentDataItem);
                            }}
                            className="btn btn-default btn-sn col-md-8 mb-2 "
                          >
                            Hire
                          </button>
                        </div>
                        <div className="mb-2">
                          <button
                            onClick={() => {
                              setInviteModal(true);
                              setHireModal(false);
                              setSelectedfreelancer(profileTalentDataItem);
                            }}
                            className="btn btn-primary btn-sn col-md-8 mb-2"
                          >
                            Invite Job
                          </button>
                        </div>
                        <InvitationModal
                          show={inviteModal}
                          Hirecheck={hireModal}
                          freelancer={selectedfreelancer}
                          handleClose={() => {
                            setInviteModal(false);
                            setHireModal(false);
                          }}
                        />
                      </>
                    ) : (
                      console.log("sign in required")
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="mt-5 p-5">
              <h6 className="text-primary text-center mb-0">
                No Search Result Found
              </h6>
            </div>
          )}
        </section>
        <br />
        {/* Display the navigation buttons */}
        {totalPages > 1 && (
          <nav>
            <ul className="pagination justify-content-center">
              {[...Array(totalPages)].map((_, index) => {
                const pageNumber = index + 1;
                return (
                  <li
                    key={pageNumber}
                    className={`page-item ${
                      pageNumber === currentPage ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                );
              })}
            </ul>
          </nav>
        )}
      </div>
    </div>
  );
};

Talent.propTypes = {
  isAuthenticated: PropTypes.bool,
};

const mapStateToProp = (state) => ({
  auth: state.auth,
  freelancerProfile: state.freelancerProfile,
  clientProfile: state.clientProfile,
});

export default connect(mapStateToProp, { freelancerGetbyId , skillsGet })(Talent);
